import React, { Component } from "react";
import { Card, Row, Col, Tooltip } from "antd";
import DentalServiceHeader from "./DentalServiceHeader";
import DentalServiceData from "./DentalServiceData";
import InstServiceHeader from "./InstServiceHeader";
import InstServiceData from "./InstServiceData";
import ProfServiceHeader from "./ProfServiceHeader";
import ProfServiceData from "./ProfServiceData";
import { Fragment } from "react";
// import InfoIcon from "../../memberSearch/InfoIcon.svg";
import CollapsibleServiceData from "./CollapsibleServiceData"

export default class PaymentDetails extends Component {
  render() {
    const claimSummary = this.props.claimSummary
    const serviceInformation = this.props.serviceInformation
    const paymentInformtaions = this.props.paymentInformtaions
    const icdCodes = this.props.icdCodes
    return (
      <Fragment>
        <Card className="pb-3 mb-3 px-3 pt-2">
          <div
            className="details-header-sub mx-2"
            style={{ display: "inline-block" }}
          >
            01. Payment information
          </div>
          <div
            className="details-header-row m-2"
            style={{ display: "inline-block m-2", float: "right" }}
          >
            Payable Amt.: <span className="details-header-sub">{paymentInformtaions.payableAmount ? "$ " + parseFloat(paymentInformtaions.payableAmount).toFixed(2) : "$ 0.00"}</span>
          </div>

          {/* justify="space-between" type="flex" */}
          <Row className="mx-4 mt-3">
            <Col span={5} className="details-header-row pr-1">
              Adjustment <div className="black-text">{paymentInformtaions.totalAdjustmentAmount ? "$ " + parseFloat(paymentInformtaions.totalAdjustmentAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Deductible <div className="black-text">{paymentInformtaions.totalDeductibleAmount ?  "$ " + parseFloat(paymentInformtaions.totalDeductibleAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Coinsurance <div className="black-text">{paymentInformtaions.totalCoInsuranceAmount ? "$ " + parseFloat(paymentInformtaions.totalCoInsuranceAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Copay{" "}
              <div className="black-text">
              {paymentInformtaions.totalCopayAmount ? "$ " + parseFloat(paymentInformtaions.totalCopayAmount).toFixed(2) : "$ 0.00"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Total Payment Amt. <div className="black-text">{paymentInformtaions.totalPaymentAmount ? '$ ' + parseFloat(paymentInformtaions.totalPaymentAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
          </Row>

          <Row className="mx-4 mt-4">
            <Col span={5} className="details-header-row pr-1">
              A/R Balance <div className="black-text">{paymentInformtaions.arBalance ? '$ ' + parseFloat(paymentInformtaions.arBalance).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              IS A/R Amt. Eligible{" "}
              <div className="black-text">
              {paymentInformtaions.isARAmountEligible ? "Yes" : "No"}
              </div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Interest Payable <div className="black-text">{paymentInformtaions.interestPayable ? "$ " + parseFloat(paymentInformtaions.interestPayable).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Recovery Amt. <div className="black-text">{paymentInformtaions.recoveryAmount ? "$ " + parseFloat(paymentInformtaions.recoveryAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Net Payment Amt. <div className="black-text">{paymentInformtaions.netTotalPaymentAmount ? "$ " + parseFloat(paymentInformtaions.netTotalPaymentAmount).toFixed(2) : "$ 0.00"}</div>
            </Col>
          </Row>

          <Row className="mx-4 mt-4">
            <Col span={5} className="details-header-row pr-1">
              OK Pay Date <div className="black-text">{paymentInformtaions.okPayDate ? paymentInformtaions.okPayDate : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Paid Date <div className="black-text">{paymentInformtaions.paidOn ? paymentInformtaions.paidOn : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
               Cheque Number <div className="black-text">{paymentInformtaions.chequeNumber ? paymentInformtaions.chequeNumber : "---"}</div>
            </Col>
            <Col span={5} className="details-header-row pr-1">
              Plan CRN{" "}
              <div className="black-text">
              {paymentInformtaions.crnNumber ? paymentInformtaions.crnNumber : "---"}
              </div>
            </Col>
            <Col span={4} className="details-header-row pr-1">
              Allowed Amount{" "}
              <div className="black-text">
                {paymentInformtaions.allowedAmount ? "$ " + parseFloat(paymentInformtaions.allowedAmount).toFixed(2) : "$ 0.00"}
              </div>
            </Col>
          </Row>

          {claimSummary.isClaimLevelPriced === "True" && claimSummary.claimNumber[0] === "I" && 
          <div>
          <Row className="ant-card-bordered table-header-background mt-4 mb-5 px-3 py-1"  justify="space-around">
            <Col span="12">
              <div className="claims-text-data" style={{color: "#16345F"}}>Claim Level Pricing</div>
            </Col>
            <Col span="12">
            <div style={{textAlign: "end"}}>
              <span className="mr-5 details-header-sub"> DRG Code:
                {"  "} {claimSummary.drgCode ? claimSummary.drgCode : " ---"}
              </span>
              <span className="mr-5 details-header-sub"> DRG Code Weight:
                {"  "} {claimSummary.drgCodeWeight ? claimSummary.drgCodeWeight : " ---"}
              </span>
              </div>
            </Col>
          </Row>

           {this.props.adjustmentDetails && this.props.adjustmentDetails.length > 0 && <Row>
            <CollapsibleServiceData
              claimNumber={claimSummary.claimNumber}
              isClaimLevelPriced={claimSummary.isClaimLevelPriced}
              adjustmentDetails={this.props.adjustmentDetails ? this.props.adjustmentDetails : []}
            />
          </Row>}
          </div>}
        </Card>
        {/* Second Div in payment tab */}  
        <Card className="pb-1 pl-3 mb-3">
          <Row className="mx-2">
            <Col span={4} className="font-12">
              <Col className="pt-2">
                <b>Primary ICD 10: </b>
                {icdCodes && icdCodes.length > 0 && <div
                  style={{
                    display: "inline-block",
                    height: "7px",
                    width: "7px",
                  }}
                  className="ml-1 cercle cercle-green"
                ></div>}
              </Col>
              {/* <Col>
                MOOP Amt: 
                <span className="black-text">{paymentInformtaions.moopAmount ? ' $ ' + paymentInformtaions.moopAmount : " $ 0.00"}</span>
              </Col> */}
            </Col>
            <Col span={20} className="pt-2 pb-3 border-vertical-small">
            <div className="">
              <Row className="ml-5">
                {icdCodes && icdCodes.map((code) => (
                <span className="mx-3 details-header-row" >
                  <span className={code.isPrimary ? 'primary-badge' : 'code-badge'}> {code.icd}</span>
                </span>
                )
                )}
              </Row>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Third Row In payment section */}

        <Card className="pb-2">
          {claimSummary.claimNumber && claimSummary.claimNumber[0] === "P"
          && <div>
            <div className="table-header-background pb-2 ">
              <ProfServiceHeader />
            </div>
            <ProfServiceData serviceInformation={serviceInformation} />
          </div>
          }
          {claimSummary.claimNumber && claimSummary.claimNumber[0] === "I"
          && <div>
            <div className="table-header-background pb-2">
              <InstServiceHeader />
            </div>
            <InstServiceData
              claimSummary={claimSummary}
              serviceInformation={serviceInformation} />
          </div>
          }
          {claimSummary.claimNumber && claimSummary.claimNumber[0] === "D"
          && <div>
            <div className="table-header-background pb-2">
              <DentalServiceHeader />
            </div>
            <DentalServiceData serviceInformation={serviceInformation} />
          </div>
          }
         
        </Card>
      </Fragment>
    );
  }
}
